<template>
  <div class="c-carousel c-carousel--roundedArrow">
    <Swiper
      ref="carouselRef"
      :modules="swiperModules"
      :slides-per-view="slidesPerView"
      :space-between="spaceBetween"
      :loop="loop"
      :centered-slides="centeredSlides"
      :autoplay="autoplayOption"
      :breakpoints="breakpointsOption"
      :navigation="{ prevEl: prevEl, nextEl: nextEl }"
      :pagination="{ el: paginationEl, clickable: true }"
    >
      <slot />
    </Swiper>

    <!-- Navigation -->
    <div ref="prevEl" class="c-carousel__prev">
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div ref="nextEl" class="c-carousel__next">
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- Pagination -->
    <div ref="paginationEl" class="c-carousel__pagination"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { Swiper } from "swiper/vue";
import { Pagination, Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

export default defineComponent({
  name: "AppCarousel2",
  components: { Swiper },
  props: {
    mergeOptions: { type: Object, default: () => ({}) }
  },
  setup(props) {
    const carouselRef = ref<any>(null);
    const prevEl = ref<HTMLElement | null>(null);
    const nextEl = ref<HTMLElement | null>(null);
    const paginationEl = ref<HTMLElement | null>(null);

    const swiperModules = [Pagination, Navigation, Autoplay];

    const slidesPerView = computed(() => props.mergeOptions.slidesPerView ?? 1.3);
    const spaceBetween = computed(() => props.mergeOptions.spaceBetween ?? 24);

    // スライド数に応じて loop を有効化
    const loop = computed(() => (props.mergeOptions.slidesCount ?? 0) > 1);

    const centeredSlides = ref(window.innerWidth < 1024);

    const autoplayOption = { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true };

    const breakpointsOption = {
      1024: {
        slidesPerView: props.mergeOptions.breakpoints?.["1024"]?.slidesPerView ?? 3,
        centeredSlides: false
      }
    };

    const onResize = () => { centeredSlides.value = window.innerWidth < 1024; };
    onMounted(() => window.addEventListener("resize", onResize));

    return {
      carouselRef,
      prevEl,
      nextEl,
      paginationEl,
      slidesPerView,
      spaceBetween,
      loop,
      centeredSlides,
      autoplayOption,
      breakpointsOption,
      swiperModules
    };
  }
});
</script>

<style scoped lang="scss">
.c-carousel {
  position: relative;

  &__prev, &__next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    cursor: pointer;
    background: rgba(255,255,255,0.7);
    border-radius: 50%;
    padding: 0.25rem;
  }
  &__prev { left: 0; }
  &__next { right: 0; }

  &__pagination {
    text-align: center;
    margin-top: 0.5rem;
  }
}
</style>
